import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const WEBHOOK_DELIVERIES_TABLE_STORAGE_KEY = "webhookDeliveriesTableStorageKey";
export const WEBHOOK_DELIVERIES_TABLE_FILTERS_STORAGE_KEY =
  "webhookDeliveriesTableFiltersStorageKey";

export enum WEBHOOK_DELIVERIES_COLUMN_ID {
  ID = "ID",
  STATUS = "STATUS",
  TIMESTAMP = "TIMESTAMP",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 800;

export const WEBHOOK_DELIVERIES_TABLE_COLUMNS_CONFIG: Record<
  WEBHOOK_DELIVERIES_COLUMN_ID,
  TableColumnMeta
> = {
  [WEBHOOK_DELIVERIES_COLUMN_ID.ID]: {
    id: WEBHOOK_DELIVERIES_COLUMN_ID.ID,
    title: "Delivery ID",
    minWidth: 200,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [WEBHOOK_DELIVERIES_COLUMN_ID.STATUS]: {
    id: WEBHOOK_DELIVERIES_COLUMN_ID.STATUS,
    title: "Status code",
    minWidth: 120,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [WEBHOOK_DELIVERIES_COLUMN_ID.TIMESTAMP]: {
    id: WEBHOOK_DELIVERIES_COLUMN_ID.TIMESTAMP,
    title: "Delivered at",
    minWidth: 160,
    defaultWidth: 220,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [WEBHOOK_DELIVERIES_COLUMN_ID.DROPDOWN]: {
    id: WEBHOOK_DELIVERIES_COLUMN_ID.DROPDOWN,
    title: "Table configuration",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<WEBHOOK_DELIVERIES_COLUMN_ID, string> = {
  [WEBHOOK_DELIVERIES_COLUMN_ID.ID]: "id",
  [WEBHOOK_DELIVERIES_COLUMN_ID.STATUS]: "status",
  [WEBHOOK_DELIVERIES_COLUMN_ID.TIMESTAMP]: "timestamp",
  [WEBHOOK_DELIVERIES_COLUMN_ID.DROPDOWN]: "dropdown",
};

/** Matches `useTableSort` / URL: sort key is the encoded column field (`SORT_CONFIG` value), not the column id. */
export const INITIAL_SORT_OPTION = SORT_CONFIG[WEBHOOK_DELIVERIES_COLUMN_ID.TIMESTAMP];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
